import { postRequest } from '../config/auth';
import { FORGOT_PASSWORD } from '../config/api-url';

export const forgotPasswordAPI = (data) => postRequest(`${FORGOT_PASSWORD}`, data);
